'use client';

import { useEffect, useState } from 'react';
import { getStoredToken } from './auth-client';
import { isDevAuthBypassEnabled } from './dev-auth';

/**
 * Lightweight auth state for landing pages. Reads mix_auth_token from
 * localStorage and re-checks on `mix_auth_change` (our in-app event,
 * dispatched by setStoredToken) and on the browser `storage` event
 * (so a login in another tab reflects here).
 */
export function useAuth(): { authed: boolean; ready: boolean; bypass: boolean } {
  const [authed, setAuthed] = useState(false);
  const [ready, setReady] = useState(false);
  const bypass = isDevAuthBypassEnabled();

  useEffect(() => {
    if (bypass) {
      setAuthed(true);
      setReady(true);
      return;
    }

    const check = () => {
      setAuthed(Boolean(getStoredToken()));
      setReady(true);
    };
    check();
    window.addEventListener('mix_auth_change', check);
    window.addEventListener('storage', check);
    return () => {
      window.removeEventListener('mix_auth_change', check);
      window.removeEventListener('storage', check);
    };
  }, [bypass]);

  return { authed, ready, bypass };
}
